import React from 'react';
import PropTypes from 'prop-types';
import { maskingClassNames } from './constants';
import { WixStyleReactMaskingContext } from './context';
const WixStyleReactMaskingProvider = ({ children, }) => (React.createElement(WixStyleReactMaskingContext.Provider, { value: { maskingClassNames } }, children));
WixStyleReactMaskingProvider.displayName = 'WixStyleReactMaskingProvider';
WixStyleReactMaskingProvider.propTypes = {
    /** any content to be displayed */
    children: PropTypes.node,
};
export default WixStyleReactMaskingProvider;
//# sourceMappingURL=WixStyleReactMaskingProvider.js.map